import WikiDetailScreen from "@/src/screens/wiki/wiki-detail-screen/wiki-detail-screen";

export default function WikiArticleDetail() {
  return <WikiDetailScreen />;
}
